<template>
  <div
    id="app"
    :class="`lang-${$i18n.locale}`"
  >
    <router-view />
  </div>
</template>
<script>
import Cookies from "js-cookie";
export default {
  data() {
    return {};
  },
  created() {
    if (!this.IsPC()) {
      //pc
      let str = window.location.href;
      let arr = [
        "/",
        "openclassSharePage",
        "albumSharePage",
        "liveSharePage",
        "resourceSharePage",
      ];
      arr.forEach((item) => {
        if (str.indexOf(item) !== -1) {
          switch (item) {
            case "/":
              window.location.href = `${location.origin}/wap/`;
              break;
            case "openclassSharePage":
              window.location.href =
                `${location.origin}/wap/pages/video/share?` + str.split("?")[1];
              break;
            case "albumSharePage":
              window.location.href =
                `${location.origin}/wap/pages/album/album-share?` +
                str.split("?")[1];
              break;
            case "liveSharePage":
              window.location.href =
                `${location.origin}/wap/pages/live/live-share?` +
                str.split("?")[1];
              break;
            case "resourceSharePage":
              window.location.href =
                `${location.origin}/wap/pages/resource/resource-share?` +
                str.split("?")[1];
              break;
            default:
              break;
          }
        }
      });
    }
    this.getAccessToken();
  },
  methods: {
    // 由于商学院登录页闪烁问题，在2022-09-27修改  by王
    // getScene() {
    //     const success = res =>{
    //         let number1 = res.data - 1

    //         this.$store.commit("SET_ISITCSCENCE", number1);
    //         if(number1) {
    //             // 修改element ui 主题颜色
    //             // this.toggleClass(document.body,'custom-E62125')
    //         }else{
    //             // this.toggleClass(document.body,'custom-409EFF')
    //         }
    //     }
    //     const fail = res => {}
    //     this.$ajax.get('api/login/frontVersion', {func: {success, fail}})
    // },
    IsPC() {
      return !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    getAccessToken() {
      let self = this;
      self.$ajax
        .get("/accessToken", {
          params: {
            company: "BL",
            device_name: "TE-0600R",
            data: {
              client_id: "20882088",
              secret: "nGk5R2wrnZqQ02bed29rjzax1QWRIu1O",
            },
          },
        })
        .then((response) => {
          localStorage.setItem("access_token", response.data.data.access_token);
          this.checkIsTencentCloud();
          this.getLang();
          this.checkWap();
          this.checkIsGray();
          // this.getScene()
        });
    },
    checkIsTencentCloud() {
      // 获取当前是否为腾讯云
      let success = (res) => {
        // console.log(res, '腾讯云') // 值为返回值，返回1为腾讯云
        let data = res.data.is_cloud;
        let tencent = data;
        sessionStorage.setItem("tencentCloud", tencent);
        sessionStorage.setItem("AppId", res.data.AppId);
      };
      this.$ajax.get("api/tencentcloudvideo/is_cloud", {
        func: { success },
      });
    },
    // 获取当前的语言版本
    getLang() {
      let success = (res) => {
      
        this.$i18n.locale = res.data.default_lang;
        Cookies && Cookies?.set("think_var", res.data.default_lang);
        localStorage.setItem("lang", res.data.default_lang);
      };
      this.$ajax.get("api/login/get_default_lang", {
        params: {},
        func: { success: success },
      });
    },
    // 判断当前登陆的是手机用户还是pc用户
    checkWap() {
      let success = (res) => {
        if (res.data == "yes") {
          window.location.href = sessionStorage.getItem("host_addr") + "/wap/";
        }
      };
      this.$ajax.get("api/login/get_use_hls", {
        params: {},
        func: { success: success },
      });
    },
    //查看页面是否置灰
    checkIsGray() {
      let success = (res) => {
        if (res.data.status === true) {
          document.getElementsByTagName("body")[0].classList.add("is-gray");
        } else {
          document.getElementsByTagName("body")[0].classList.remove("is-gray");
        }
      };
      let fail = (res) => {};
      this.$ajax({
        url: "api/setting/gray",
        method: "get",
        params: {},
        func: { success, fail },
      });
    },
  },
};
</script>
<style lang="scss">
body,
html,
#app {
  // background: #eafaff;
  background: #e9ecf3;
}
.is-gray {
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
  filter: gray;
}
</style>


